import {Component, EventEmitter, inject, OnDestroy, Output} from '@angular/core';
import {
  tap,
  filter,
  map,
  take, BehaviorSubject, switchMap, scan,

} from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {InlineSVGModule} from "ng-inline-svg-2";
import {AvatarAsLetterDirectiveModule, UserHttpService} from "@lcms/shared/data-access-user";
import {FormsModule} from "@angular/forms";
import {SelectFilterComponent} from "@lcms/shared/lazy-load-select";
import {NgxShimmerLoadingModule} from "ngx-shimmer-loading";
import {SharedSearchFormationModule} from "../../shared-search-formation.module";
import {SearchFormationService} from "../../serivce/search-formation.service";

@Component({
  selector: 'lcms-search-page',
  standalone : true,
  imports: [CommonModule,
    TranslateModule,
    InlineSVGModule,
    AvatarAsLetterDirectiveModule,
    FormsModule,
    SelectFilterComponent,
    NgxShimmerLoadingModule, SharedSearchFormationModule, RouterLink,],
  templateUrl: './search-page-Formation.component.html',
  styleUrls: ['./search-page-Formation.component.scss'],
})
export class SearchPageFormationComponent {
  userService = inject(UserHttpService)
  sanitizer = inject(DomSanitizer);
  searchService = inject(SearchFormationService);
  router = inject(Router);
  activateRoute = inject(ActivatedRoute);
  // searchQ=this.searchService.searchKeyworld.value;
  isLoading = this.searchService.searching;
  // selectedCategory=new BehaviorSubject('');
  resultsCategories: any;
  typeCatalogue:any = [{id:1 , label : 'Formation/Module' ,value : 'catalogue'} ,{id:2 , label : 'Ressources' , value: 'ressources'}]
  categoriesLoad = false
  selectedCategories : any[]= this.searchService.tags.value?? []
  selectedtype : any[] =this.searchService.typeFormation.value ??[]
  type$ = this.searchService.typeFormation.asObservable().pipe(
    map((data)=>data.sort((a, b) => a.value.localeCompare(b.value)))
  )
  selectedSub  = new BehaviorSubject<any[]>([])
  selectedTypeSub  = new BehaviorSubject<any[]>([])
  selected$  = this.selectedSub.asObservable()
  selectedType$  = this.selectedSub.asObservable()
  keyword = '';
  searching = this.searchService.searching;
  last_page = 1;
  tagPage = new BehaviorSubject<any>({ page: 1,searchTerm: ''});
  tagsPage$ = this.tagPage.asObservable();
  listCategories$ =    this.tagsPage$.pipe(
    tap(() => this.categoriesLoad = true ),
    switchMap(({page,searchTerm})=> this.userService.getInterest(page,searchTerm,1).pipe(
      map((data)=>{
        this.last_page = data?.last_page;
        return data?.data
      }),

    )),scan((acc, data)=>{
      // If the search term has changed or if it's the first load
      if(this.tagPage.value.page !== 1){
        return [...acc, ...data];
      }else{
        return data;
      }
    }),
    tap(() => this.categoriesLoad = false ),
  )

  // currentQuery$ = this.activateRoute.queryParams
  //   .pipe(
  //     filter(
  //       (o: { query?: string }) =>
  //         !(this.searchService.checkKeyword(o?.query || '') && this.searchService.tags.value?.length>0)
  //     ),
  //     map((o: { query?: string }) => o.query),
  //     tap((term: any) => this.searchService.searchKeyworld.next(term)),
  //     take(1)
  //   )
  //   .subscribe();

  results$ = this.searchService.searchResult$.pipe(
    tap((res) => {
      this.searchService.dataResult.next(res)
      this.resultsCategories = [
        {
          title: 'all',
          key: '',
          isActive: true,
          nbr: Object.values(res).reduce(
            (acc, temp: any) => acc + temp.length,
            0
          ),
        },
        ...Object.keys(res)
          .filter((rkey) => res[rkey].length > 0)
          .map((rkey) => ({
            title: rkey,
            key: rkey,
            isActive: false,
            nbr: res[rkey].length,
          })),
      ];
    }),
  );

  handleActive(item: any) {
    this.resultsCategories = this.resultsCategories.map((res: any) =>
      res === item ? { ...res, isActive: true } : { ...res, isActive: false }
    );
    // this.selectedCategory.next(item?.key ?? '');
    this.searchService.setCheckedCategory((item?.key as string) || '');
  }

  search(event: any) {
    this.router.navigate([], {
      relativeTo: this.activateRoute,
      queryParams: { query: event.target.value },
      queryParamsHandling: 'merge',
    });
    this.searchService.searchByAnswer.next(false);
    if (event.key === 'Enter') {
      this.searchService.searchByAnswer.next(true);
    }

    if (!this.searchService.checkKeyword(event.target.value || '') || event.key === 'Enter' )
      this.searchService.searchKeyworld.next(event.target.value);
    // if(this.searchQ!== this.searchService.searchKeyworld.value)
  }
  getKeys(obj: any) {
    const keys  = Object.keys(obj);
    return keys.sort((a, b) => a.localeCompare(b));
  }
  searchTag(searchTerm: string) {
    this.tagPage.next({page:1,searchTerm: searchTerm})
  }

  onSelectedCateChange(selectedItem: any) {

    const existingIndex = this.selectedCategories.findIndex((u: any ) => u.id === selectedItem.id);

    if (existingIndex === -1) {
      // L'utilisateur n'est pas déjà présent, alors on l'ajoute
      this.selectedCategories.push(selectedItem);
      this.selectedSub.next(this.selectedCategories)
      this.searchService.tags.next(this.selectedCategories)
    } else {
      // L'utilisateur est déjà présent, on le supprime
      this.selectedCategories.splice(existingIndex, 1);
      this.selectedSub.next(this.selectedCategories)
      this.searchService.tags.next(this.selectedCategories)
    }
    //   this.autocomplete.clear();
  }

  removecate(item: any) {
    this.selectedCategories  = this.selectedCategories.filter((cat :any)=>cat.id !==item.id)
    this.selectedSub.next(this.selectedCategories)
    this.searchService.tags.next(this.selectedCategories)
  }
  searchType(searchTerm: string) {
    this.typeCatalogue.filter((tag : any) => tag === searchTerm)

  }

  onSelectedTypeChange(selectedItem: any) {

    const existingIndex = this.selectedtype.findIndex((u: any ) => u.id === selectedItem.id);

    if (existingIndex === -1) {
      // L'utilisateur n'est pas déjà présent, alors on l'ajoute
      this.selectedtype.push(selectedItem);
      this.selectedTypeSub.next(this.selectedtype)
      this.searchService.typeFormation.next(this.selectedtype)
    } else {
      // L'utilisateur est déjà présent, on le supprime
      this.selectedtype.splice(existingIndex, 1);
      this.selectedTypeSub.next(this.selectedtype)
      this.searchService.typeFormation.next(this.selectedtype)
    }
    //   this.autocomplete.clear();
  }

  removeType(item: any) {
    this.selectedtype  = this.selectedtype.filter((cat :any)=>cat.id !==item.id)
    this.selectedTypeSub.next(this.selectedtype)
    this.searchService.typeFormation.next(this.selectedtype)
  }

  goto(): void {
    this.searchService.typeFormation.next([])
    this.searchService.tags.next([])
    this.searchService.searchKeyworld.next('')
    this.searchService.searchByAnswer.next(false)
    this.router.navigate(['/formation'])
  }
  tagsloadMor(loadMore:number) {
    const page = this.tagPage.value.page;
    if(page+1 <= this.last_page){
      const searchTerm = this.tagPage.value.searchTerm;
      this.tagPage.next({page:page+loadMore,searchTerm: searchTerm})
    }
  }
}
